import { GlNavItem, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
export default {
    name: 'HelpCenterUpgradeSubscription',
    components: {
        GlNavItem
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    i18n: {
        upgradeSubscription: __('Upgrade subscription')
    },
    inject: [
        'isIconOnly'
    ],
    props: {
        upgradeLink: {
            type: String,
            required: true
        }
    }
};
